// A person's round avatar: their profile picture, or their initials when they have none.
import type { CSSProperties } from 'react';
import { usePersonPicture } from './pictures';
import styles from './Avatar.module.css';

interface AvatarProps {
  personGuid: string | null | undefined;
  initials: string;
  /** Diameter in pixels. */
  size?: number;
}

export function Avatar({ personGuid, initials, size = 36 }: AvatarProps) {
  const picture = usePersonPicture(personGuid);
  const style = { '--avatar-size': `${size}px` } as CSSProperties;
  return (
    <span className={styles.avatar} style={style} aria-hidden="true">
      {picture ? <img src={picture} alt="" className={styles.picture} /> : initials}
    </span>
  );
}
